"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSpoofHeaders = exports.selectMimicHeaders = exports.selectLocaleHeaders = exports.selectIdentificationHeaders = exports.toHeadersRecord = exports.selectAllHeaders = exports.toHeader = void 0;

var _auth = require("./auth");

var _identification = require("./identification");

var _locale = require("./locale");

var _spoof = require("./spoof");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var toHeader = function toHeader(key, value) {
  return {
    key: key,
    value: value
  };
};

exports.toHeader = toHeader;

var hasValue = function hasValue(header) {
  return Boolean(header.value);
};

var selectAllHeaders = function selectAllHeaders(state) {
  return [].concat(_toConsumableArray(selectIdentificationHeaders(state)), _toConsumableArray(selectLocaleHeaders(state)), _toConsumableArray(selectMimicHeaders(state)), _toConsumableArray(selectSpoofHeaders(state)));
};

exports.selectAllHeaders = selectAllHeaders;

var toHeadersRecord = function toHeadersRecord(headers) {
  return headers.reduce(function (record, header) {
    record[header.key] = header.value;
    return record;
  }, {});
};

exports.toHeadersRecord = toHeadersRecord;

var selectIdentificationHeaders = function selectIdentificationHeaders(state) {
  var identifiers = (0, _identification.selectIdentifiers)(state);

  if (identifiers) {
    var headers = [toHeader('X-Device-Group', identifiers.deviceGroup), toHeader('X-Device-Type', identifiers.deviceType), toHeader('X-Device-App', identifiers.deviceApp), toHeader('X-Device-Platform', identifiers.devicePlatform), toHeader('X-Device-Model', identifiers.deviceModel), toHeader('X-Device-Id', identifiers.deviceId), toHeader('X-Client-Version', identifiers.clientVersion), toHeader('X-Player-Version', identifiers.playerVersion), toHeader('X-Profile-Id', identifiers.profileId), toHeader('X-Supported-Codecs-List', identifiers.supportedCodecs), toHeader('X-Supported-HDRModes-List', identifiers.supportedHdrModes)];
    return headers.filter(hasValue);
  }

  return [];
};

exports.selectIdentificationHeaders = selectIdentificationHeaders;

var selectLocaleHeaders = function selectLocaleHeaders(state) {
  var _selectLocaleState = (0, _locale.selectLocaleState)(state),
      navigatorPostalCode = _selectLocaleState.navigatorPostalCode,
      language = _selectLocaleState.language,
      acceptLanguage = _selectLocaleState.acceptLanguage,
      clientIP = _selectLocaleState.clientIP;

  return [toHeader('X-Client-Postal', navigatorPostalCode), toHeader('X-Preferred-Language', language), toHeader('Accept-Language', acceptLanguage), // Needed for smarttv clients that don't set it automatically
  toHeader('X-Forwarded-For', clientIP) // used to pass client IP to server side api calls
  ].filter(hasValue);
};

exports.selectLocaleHeaders = selectLocaleHeaders;

var selectMimicHeaders = function selectMimicHeaders(state) {
  return [toHeader('X-Mimic-Token', (0, _auth.selectMimicToken)(state))].filter(hasValue);
};

exports.selectMimicHeaders = selectMimicHeaders;

var selectSpoofHeaders = function selectSpoofHeaders(state) {
  return [toHeader('X-Country-Code3', (0, _spoof.selectSpoofedCountry)(state)), toHeader('X-Postal-Code', (0, _spoof.selectSpoofedCurrentPostal)(state)), toHeader('X-DMA', (0, _spoof.selectSpoofedDma)(state))].filter(hasValue);
};

exports.selectSpoofHeaders = selectSpoofHeaders;